import React, { useRef, useState } from 'react';
import { Wizard, Card, NotificationList } from 'quanta-ui';
// import PayPremium from '../../../../common/pay-premium/pay-premium-two-wheeler';
import { CarPayPremium } from 'quanta-flows/modules/common/payPremium';
import ReviewRenewConfirmDetails from './review-renew-confirm';
// import Loading from '../../../../../lib/layout/loading';
import { Loading } from 'quanta-flows/modules/layout';
// import { updateViewRenewMotorPolicyVar } from '../_graphql/state';
import { updateViewRenewMotorPolicyVar } from 'quanta-flows/modules/policy/renewal/motor/state';
import { GET_VIEW_RENEW_MOTOR_POLICY_VAR_DETAILS } from '../queries';
// import SuccessPage from '../../../../common/successPage/two-wheeler';
import { SuccessPageTW } from 'quanta-flows/modules/common/success';
import { useQuery } from '@apollo/client';
export default function RenewViewPolicyWizardPanel({
  lobCode,
  lobName,
  productCode,
  productName,
  productType,
  renewalMode,
  rcStatus,
  UWCompleted,
  modify,
  ...props
}) {
  const [successMsg, showSuccessMsg] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const [loadingStep, setLoadingStep] = useState(false);
  const [showWizardButtonPanel, setShowWizardButtonPanel] =
    useState(null);
  const [customLoadingMessage, setCustomLoadingMessage] =
    useState(null);
  const payAndPremiumRef = useRef();
  const renderExpandedCards = useRef([
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  const { loading, error, data } = useQuery(
    GET_VIEW_RENEW_MOTOR_POLICY_VAR_DETAILS,
  );
  const renderPayPremiumCards = useRef([
    {cardName: 'cheque 1',flag: true},
    { cardName: 'dd 1', flag: true },
  ]);

  const expandedCard = useRef([
    {
      cardName: 'intermediaryDetails',
      cardFlag: false,
      subSections: [],
    },
    {
      cardName: 'proposerDetails',
      cardFlag: false,
      subSections: [],
    },
    {
      cardName: 'vehicleAndRegistrationDetails',
      cardFlag: false,
      subSections: [],
    },
    {
      cardName: 'financeDetails',
      cardFlag: false,
      subSections: [],
    },
  ]);
  const [enableRenew, setEnableRenew] = useState(true);

  const steps = [
    {
      label: 'Review Renewal Proposal',
      proceedLabel: () => 'Renew',
      // disabledLabel: !enableRenew,
       disabledLabel: !enableRenew || (rcStatus==='true'&&data?.viewRenewMotorPolicy?.proposalStatus!=='RCCN')|| (UWCompleted&&data?.viewRenewMotorPolicy?.enablecalcrenew&&data?.viewRenewMotorPolicy?.proposalStatus!=='RCCN'),
      // disabledLabel: !enableRenew || !rcStatus,
      submitForm: async () => {
        setAlerts([]);
        if (props?.forwardedRenewFormRef?.current) {
          const res =
            await props?.forwardedRenewFormRef?.current?.submitForm();
          return res;
        }
        return false;
      },
      stepNotCompleteAlert: () => {
        let errorCountVehicle = 0;
        if (
          props?.forwardedRenewFormRef?.current?.errors
            ?.vehicleTabDetails
        ) {
          errorCountVehicle += Object.keys(
            props?.forwardedRenewFormRef?.current?.errors
              ?.vehicleTabDetails,
          ).length;
        }
        setAlerts([
          {
            header: 'Unable to proceed',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>
                  {!props?.forwardedRenewFormRef?.current?.values
                    ?.intermediaryData?.businessLocation
                    ? `Please select appropriate Business Location before proceeding`
                    : expandedCard?.current?.find(
                        (exp) => exp?.cardName === 'proposerDetails',
                      )?.cardFlag
                    ? `Please save the changes in proposer details before proceeding`
                    : props?.forwardedRenewFormRef?.current?.errors
                        ?.proposerDetails &&
                      Object.keys(
                        props?.forwardedRenewFormRef?.current?.errors
                          ?.proposerDetails,
                      )?.length > 0
                    ? `Please review the proposer details section before proceeding`
                    : expandedCard?.current?.find(
                        (exp) =>
                          exp?.cardName ===
                          'vehicleAndRegistrationDetails',
                      )?.cardFlag
                    ? `Please save the changes in vehicle details before proceeding`
                    : errorCountVehicle > 0
                    ? `Please review the vehicle and registration details section before proceeding`
                    : expandedCard?.current?.find(
                        (exp) => exp?.cardName === 'financeDetails',
                      )?.cardFlag
                    ? `Please save the changes in finance details before proceeding`
                    : expandedCard?.current?.find(
                        (exp) =>
                          exp?.cardName === 'intermediaryDetails',
                      )?.cardFlag
                    ? `Please save the changes in intermediary details before proceeding`
                    : props?.forwardedRenewFormRef?.current?.errors
                        ?.additionalTabDetails &&
                      Object.keys(
                        props?.forwardedRenewFormRef?.current?.errors
                          ?.additionalTabDetails,
                      )?.length > 0
                    ? `Please review the  Nominee Details in finance details section before proceeding`
                    : `Please fill the mandatory fields before proceeding`}
                </span>
              </div>
            ),
            type: 'warning',
            timeout: null,
            disableClose: false,
          },
        ]);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
      component: ({ expanded, goToStep }) =>
        expanded ? (
          loadingStep ? (
            <div className="min-h-screen">
              <Loading customMessage={customLoadingMessage} />
            </div>
          ) : (
            <ReviewRenewConfirmDetails
              forwardedRenewFormRef={props?.forwardedRenewFormRef}
              forwardedPremiumFormRef={props?.forwardedPremiumFormRef}
              forwardedAlertsRef={props?.forwardedAlertsRef}
              {...{
                lobCode,
                lobName,
                productCode,
                productName,
                productType,
                goToStep,
                renderExpandedCards,
                expandedCard,
                renewalMode,
                setParentAlerts: setAlerts,
                setLoadingStep,
                setCustomLoadingMessage,
                setEnableRenew,
	            	rcStatus,
                 UWCompleted,
                 modify
              }}
            />
          )
        ) : null,
    },
    {
      label: 'Pay Premium',
      proceedLabel: () => 'Submit',
      submitForm: async () => {
        setAlerts([]);
        if (payAndPremiumRef.current) {
          const res = await payAndPremiumRef.current.submitForm();
          return res;
        }
        return false;
      },
      onPreviousStep: () => {
        if (payAndPremiumRef.current) {
          updateViewRenewMotorPolicyVar({
            premiumDetails: payAndPremiumRef?.current?.values,
          });
        }
      },
      component: ({ expanded }) =>
        expanded ? (
          loadingStep ? (
            <div className="min-h-screen">
              <Loading customMessage={customLoadingMessage} />
            </div>
          ) : (
            <CarPayPremium
              forwardedRef={payAndPremiumRef}
              {...{
                setLoadingStep,
                setCustomLoadingMessage,
                showSuccessMsg,
                setParentAlerts: setAlerts,
                setShowWizardButtonPanel,
                productCode,
                lobCode,
                lobName,
                productName,
                productType,
                REACTIVE_VAR_QUERY:
                  GET_VIEW_RENEW_MOTOR_POLICY_VAR_DETAILS,
                updateReactiveVar: updateViewRenewMotorPolicyVar,
                reactiveVarName: 'viewRenewMotorPolicy',
                modeOfOperation: 'RENEWPOLICY',
                renderExpandedCards: renderPayPremiumCards,
              }}
            />
          )
        ) : null,
      stepNotCompleteAlert: () => {
        setAlerts([
          {
            header: 'Unable to proceed',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>
                  {payAndPremiumRef?.current?.errors
                    ?.totalPaymentAmount
                    ? payAndPremiumRef?.current?.errors
                        ?.totalPaymentAmount
                    : payAndPremiumRef?.current?.errors?.onlinePayment
                        ?.isTransactionIdVerified
                    ? payAndPremiumRef?.current?.errors?.onlinePayment
                        ?.isTransactionIdVerified
                    : payAndPremiumRef?.current?.values
                        ?.termsAndConditions
                    ? `Please fill the mandatory fields before proceeding`
                    : 'Please fill the mandatory fields and accept terms and conditions before proceeding.'}
                </span>
              </div>
            ),
            type: 'warning',
            timeout: null,
            disableClose: false,
          },
        ]);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
    },
  ];

  return (
    <Card
      className="min-h-screen"
      severity={`${successMsg ? 'success' : 'info'}`}
    >
      {successMsg ? (
        <SuccessPageTW
          {...{
            lobCode,
            lobName,
            productCode,
            productName,
            productType,
            REACTIVE_VAR_QUERY:
              GET_VIEW_RENEW_MOTOR_POLICY_VAR_DETAILS,
            reactiveVarName: 'viewRenewMotorPolicy',
            renewalMode,
          }}
        />
      ) : (
        <Wizard
          {...{
            steps,
            startStep: 0,
            tabStyle: true,
            switchTabs: true,
            buttonSize: 'medium',
            showButtonPanel:
              showWizardButtonPanel !== null
                ? showWizardButtonPanel
                : !loadingStep,
          }}
        />
      )}
      <NotificationList 
        {...{
          items: alerts,
          resetAlerts: (idx) => {
            const alertToBeRemovedPos = alerts.findIndex(
              (a) => a.id === idx,
            );
            setAlerts([
              ...alerts.slice(0, alertToBeRemovedPos),
              ...alerts.slice(alertToBeRemovedPos + 1, alerts.length),
            ]);
          },
        }}
      />
    </Card>
  );
}
